import * as ACTIONS from "../actions";

import Api from "../../services";

import cm from "./CommonFunction";
// import { Promise } from "q";
// import { resolve } from "url";

const UserModule = {
  state: {
    LOADING: false,
    ERRORMESSAGE: null,
    USERS: [],
    TOTALPAGES: 1,
    DEPARTMENTS: [],

    USERSAVEERRORMESSAGE: null,
    USERSAVELOADING: false,

    ROLES: [],
  },
  getters: {
    GETUSERLOADING: (state) => state.LOADING,
    GETUSERERRORMESSAGE: (state) => state.ERRORMESSAGE,
    GETUSERS: (state) => state.USERS,
    GETUSERTOTALPAGES: (state) => state.TOTALPAGES,
    GETUSERSAVEERRORMESSAGE: (state) => state.USERSAVEERRORMESSAGE,
    GETUSERSAVELOADING: (state) => state.USERSAVELOADING,
    GETUSERROLES: (state) => state.ROLES,
    GETDEPARTMENTS: (state) => state.DEPARTMENTS,
  },
  actions: {
    [ACTIONS.USER_GETALL]: (context, url) => {
      var { commit } = context;
      commit(ACTIONS.USER_GETALL_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Users/GetAll" + url, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.USER_GETALL_SUCCESS, data.ResponseData);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.USER_GETALL_ERROR, data.StatusMessage);
            } else {
              commit(ACTIONS.USER_GETALL_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              commit(ACTIONS.USER_GETALL_ERROR, "Error " + err.status);
            }
            if (err.request) {
              commit(ACTIONS.USER_GETALL_ERROR, err.message);
            } else {
              // Something happened in setting up the request that triggered an Error

              commit(ACTIONS.USER_GETALL_ERROR, "Error " + err.message);
            }

            return reject(err);
          });
      });
    },
    [ACTIONS.USERS_GET_ROLES]: (context) => {
      var { commit } = context;

      commit(ACTIONS.USERS_GET_ROLES_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Users/GetUserRoles", {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.USERS_GET_ROLES_SUCCESS, data.ResponseData);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.USERS_GET_ROLES_ERROR, data.StatusMessage);
            } else {
              commit(ACTIONS.USERS_GET_ROLES_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              commit(ACTIONS.USERS_GET_ROLES_ERROR, "Error " + err.status);
            }
            if (err.request) {
              commit(ACTIONS.USERS_GET_ROLES_ERROR, err.message);
            } else {
              // Something happened in setting up the request that triggered an Error

              commit(ACTIONS.USERS_GET_ROLES_ERROR, "Error " + err.message);
            }

            return reject(err);
          });
      });
    },

    [ACTIONS.USERS_GET_DEPARTMENTS]: (context) => {
      var { commit } = context;

      commit(ACTIONS.USERS_GET_DEPARTMENTS_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Users/GetDepartments", {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.USERS_GET_DEPARTMENTS_SUCCESS, data.ResponseData);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.USERS_GET_DEPARTMENTS_ERROR, data.StatusMessage);
            } else {
              commit(ACTIONS.USERS_GET_ROLES_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              commit(
                ACTIONS.USERS_GET_DEPARTMENTS_ERROR,
                "Error " + err.status,
              );
            }
            if (err.request) {
              commit(ACTIONS.USERS_GET_DEPARTMENTS_ERROR, err.message);
            } else {
              // Something happened in setting up the request that triggered an Error

              commit(
                ACTIONS.USERS_GET_DEPARTMENTS_ERROR,
                "Error " + err.message,
              );
            }

            return reject(err);
          });
      });
    },
    [ACTIONS.USERS_CHECK_DUPLICATE_EMAIL]: (context, data) => {
      return new Promise((resolve, reject) => {
        let url = "users/CheckDuplicateEmail";
        var params = new URLSearchParams();
        params.append("value", data.value);
        params.append("otherData[0].key", "id");
        params.append("otherData[0].value", data.id == null ? 0 : data.id);

        Api.post(url, params, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data) {
              return resolve({
                data: data.isValid,
              });
            } else {
              return resolve({
                data: true,
              });
            }
          })
          .catch((err) => {
            return reject({
              data: true,
            });
          });
      });
    },
    [ACTIONS.USERS_CHECK_DUPLICATE_NAME]: (context, data) => {
      return new Promise((resolve, reject) => {
        let url = "users/CheckDuplicateName";
        var params = new URLSearchParams();
        params.append("value", data.value);
        params.append("otherData[0].key", "id");
        params.append("otherData[0].value", data.id == null ? 0 : data.id);
        Api.post(url, params, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data) {
              return resolve({
                data: data.isValid,
              });
            } else {
              return resolve({
                data: true,
              });
            }
          })
          .catch((err) => {
            return reject({
              data: true,
            });
          });
      });
    },
    [ACTIONS.USERS_CHECK_DUPLICATE_USERNAME]: (context, data) => {
      return new Promise((resolve, reject) => {
        let url = "users/CheckDuplicateUsername";
        var params = new URLSearchParams();
        params.append("value", data.value);
        params.append("otherData[0].key", "id");
        params.append("otherData[0].value", data.id == null ? 0 : data.id);
        Api.post(url, params, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data) {
              return resolve({
                data: data.isValid,
              });
            } else {
              return resolve({
                data: true,
              });
            }
          })
          .catch((err) => {
            return reject({
              data: true,
            });
          });
      });
    },
    [ACTIONS.USERS_SAVE]: (context, params) => {
      var { commit } = context;
      commit(ACTIONS.USERS_SAVE_PENDING);
      return new Promise((resolve, reject) => {
        Api.post("users/add", params, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.USERS_SAVE_SUCCESS, data.ResponseData);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.USERS_SAVE_ERROR, data.StatusMessage);
            } else if (data && data.StatusCode == 450) {
              commit(ACTIONS.USERS_SAVE_ERROR, "Data is not valid format.");
              return resolve(res);
            } else {
              commit(ACTIONS.USERS_SAVE_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              var { data } = err.response;
              if (err.response.status == 500) {
                context.commit(
                  ACTIONS.USERS_SAVE_ERROR,
                  "Internal server error",
                );
              } else {
                context.commit(ACTIONS.USERS_SAVE_ERROR, "Error " + err.status);
              }
            } else if (err.request) {
              context.commit(ACTIONS.USERS_SAVE_ERROR, "Error " + err.request);
            } else {
              // Something happened in setting up the request that triggered an Error

              context.commit(ACTIONS.USERS_SAVE_ERROR, "Error " + err.message);
            }
            return reject(err);
          });
      });
    },
    [ACTIONS.USERS_GET]: (context, userId) => {
      var { commit } = context;
      commit(ACTIONS.USERS_GET_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("users/GetUser" + "?id=" + userId, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.USERS_GET_SUCCESS, data.ResponseData);
              return resolve(res);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.USERS_GET_ERROR, data.StatusMessage);
            } else {
              commit(ACTIONS.USERS_GET_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              var { data } = err.response;
              if (err.response.status == 500) {
                context.commit(
                  ACTIONS.USERS_GET_ERROR,
                  "Internal server error",
                );
              } else {
                context.commit(ACTIONS.USERS_GET_ERROR, "Error " + err.status);
              }
            } else if (err.request) {
              context.commit(ACTIONS.USERS_GET_ERROR, "Error " + err.request);
            } else {
              // Something happened in setting up the request that triggered an Error

              context.commit(ACTIONS.USERS_GET_ERROR, "Error " + err.message);
            }
            return reject(err);
          });
      });
    },
  },
  mutations: {
    [ACTIONS.USER_GETALL_ERROR]: (state, msg) => {
      (state.LOADING = false), (state.ERRORMESSAGE = msg);
    },
    [ACTIONS.USER_GETALL_PENDING]: (state) => {
      (state.LOADING = true), (state.ERRORMESSAGE = null);
    },
    [ACTIONS.USER_GETALL_SUCCESS]: (state, data) => {
      state.LOADING = false;
      state.ERRORMESSAGE = null;
      (state.USERS = data.users), (state.TOTALPAGES = data.totalRecords);
    },
    [ACTIONS.USERS_GET_ROLES_PENDING]: (state) => {
      state.USERSAVELOADING = true;
      state.USERSAVEERRORMESSAGE = null;
    },
    [ACTIONS.USERS_GET_ROLES_SUCCESS]: (state, data) => {
      state.USERSAVELOADING = false;
      state.USERSAVEERRORMESSAGE = null;
      state.ROLES = data.Roles;
    },
    [ACTIONS.USERS_GET_ROLES_ERROR]: (state, msg) => {
      state.USERSAVELOADING = false;
      state.USERSAVEERRORMESSAGE = msg;
    },
    [ACTIONS.USERS_SAVE_PENDING]: (state) => {
      state.USERSAVELOADING = true;
      state.USERSAVEERRORMESSAGE = null;
    },
    [ACTIONS.USERS_SAVE_SUCCESS]: (state) => {
      state.USERSAVELOADING = false;
      state.USERSAVEERRORMESSAGE = null;
    },
    [ACTIONS.USERS_SAVE_ERROR]: (state, msg) => {
      state.USERSAVELOADING = false;
      state.USERSAVEERRORMESSAGE = msg;
    },
    [ACTIONS.USERS_GET_PENDING]: (state) => {
      state.USERSAVELOADING = true;
      state.USERSAVEERRORMESSAGE = null;
    },
    [ACTIONS.USERS_GET_SUCCESS]: (state, data) => {
      state.USERSAVELOADING = false;
      state.USERSAVEERRORMESSAGE = null;
      state.ROLES = data.roles;
      state.DEPARTMENTS = data.departments;
    },
    [ACTIONS.USERS_GET_ERROR]: (state, msg) => {
      state.USERSAVELOADING = false;
      state.USERSAVEERRORMESSAGE = msg;
    },
    [ACTIONS.USERS_GET_DEPARTMENTS_PENDING]: (state) => {
      state.USERSAVELOADING = true;
      state.USERSAVEERRORMESSAGE = null;
    },
    [ACTIONS.USERS_GET_DEPARTMENTS_SUCCESS]: (state, data) => {
      state.USERSAVELOADING = false;
      state.USERSAVEERRORMESSAGE = null;
      state.DEPARTMENTS = data.departments;
      state.ROLES = data.Roles;
    },
    [ACTIONS.USERS_GET_DEPARTMENTS_ERROR]: (state, msg) => {
      state.USERSAVELOADING = false;
      state.USERSAVEERRORMESSAGE = msg;
    },
  },
};

export default UserModule;
